<template>
  <div :class="`page-heading ${props.type.length ? 'page-heading--'+props.type : ''}`">
    <h1 class="page-heading__heading">
      {{ props.title }}
    </h1>
    <div v-if="props.date.length" class="page-heading__date">
      {{ useFormatDate('fullDateWeekdayMonth', props.date ) }}
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  title: {
    type: String,
    default: ''
  },
  date: {
    type: String,
    default: ''
  },
  type: {
    type: String,
    default: ''
  }
})
</script>

<style lang="scss">
@use "~/assets/sass/tools";

  .page-heading {
    display: flex;
    flex-direction: column;
    gap: var(--space--m);
    margin-bottom: var(--space--xxl);
    padding: 0;

    &__heading {
      @include tools.typo-heading-main;
      margin: 0;
    }

    &--news {
      @include tools.grid;

      .page-heading {
        &__heading,
        &__date {
          @include tools.page-grid-columns;
        }

        &__heading {
          @include tools.typo-heading-large;
          color: var(--color-text);
          -webkit-text-stroke: 0;
        }

        &__date {
          @include tools.typo-small;
        }
      }
    }
  }
</style>
